import React from 'react';
import styled, { css } from 'styled-components';

export const StyledArrow = styled(({ isCollapsed, Icon, ...props }) => <Icon {...props} />)`
  transform: ${({ isCollapsed }) => `rotate(${isCollapsed ? 0 : 180}deg)`};
  transition: transform 0.15s;
  margin-right: 8px;

  ${({ small }) => small && css`
    width: 24px;
    height: 24px;
    margin-right: 4px;
  `};

  ${({ large }) => large && css`
    width: 36px;
    height: 36px;
  `};
`;
